import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { IMaterialDetailModel, useAppointmentDetailsModel } from "./appointmentDetailsModels";
import { IMaterialDetailList } from "../../appointmentType";
import { formatIntPoint, formatIntPoint1, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import { DetailType, ISalesTypeEnum, IPriceTypeEnum, IServiceNatureCodeType } from "@/types/ScmEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { ITopType } from "@/types/ScmTypes";
import { YhBut } from "@/components/YhButton";
import { importPropsConfig } from "@/utils/importFile";
import { useSaleSoDetailModel } from "@/views/sale/so/view/details/saleSoDetailModel";
import useGlobalModel from "@/model/globalModel";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";

export const MaterialTableBox: FC<ITopType> = ({ id, mode, IFormRef, parentInfo }) => {
    const { shopAndOrg: { shopId }, setLoadingInfo } = useGlobalModel()

    const {
        setMaterialModel,
        detailMaterialAddList, setDetailMaterialAddList,
        detailMaterialAddDataRowKeys, setDetailMaterialAddDataRowKeys,
        setDetailMaterialAddDataRow,
        detailMaterialEditList, setDetailMaterialEditList,
        detailMaterialEditDataRowKeys, setDetailMaterialEditDataRowKeys,

        setDetailMaterialEditDataRow,
        detailMaterialLookList,
        detailMaterialDetailList,
        setHistoryVisible,
        setHistoryRow,
        detailAddForm,
        detailEditForm,
        transformsToPoMaterialDetailList
    } = useAppointmentDetailsModel();
    let { priceTypeCode, serviceNatureCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const { downloadTpl } = useSaleSoDetailModel()
    const onHistoryModel = (record: IMaterialDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const switchModelViaible = () => {
        IFormRef.current?.validateFields().then(async res => {
            setMaterialModel(true)
        })
    }
    const importCallback = async (list: IMaterialDetailModel[]) => {
        if (!list) return;
        let newImportList = await Promise.all(list?.map(async (item: any) => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, retailPrice, num, ...params } = item as { latestPurPrice: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string }
            let newPrice: number = latestPurPrice ?? purchasePrice;
            if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = lateSalePrice ?? retailPrice;
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = retailPrice;
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = latestPurPrice ?? purchasePrice;
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = purchasePrice ?? latestPurPrice;
                        break;
                }
            }
            return {
                ...item,
                id: stockId,
                num,
                price: newPrice,
            }
        }) ?? [])

        transformsToPoMaterialDetailList(mode, newImportList)
        setLoadingInfo({ loadingVisible: false, txt: "" });
    }

    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && detailEditForm.status === DictCodeEnmu.APPOINTMENT_TRANSFER || detailEditForm.status === DictCodeEnmu.APPOINTMENT_CHANGE) {
            return false;
        }
        return true;
    }
    const action = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.AP_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => switchModelViaible()}
                >新增商品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.AP_ED_DEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => detailMaterialDetailList(mode, parentInfo)}
                >删除商品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_S_ED_IM}>
                <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/sale/details/import/${shopId}`, importCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中" }))}>
                    <Button
                        disabled={!(serviceNatureCode && customerCode)}
                        className="mr-5"
                        type="primary"
                        shape="round">导入</Button>
                </Upload>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_S_ED_DLOAD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={downloadTpl}
                >下载模板</Button>
            </YhAuth>
        </>}
    </>;

    const removeMaterial = (record: IMaterialDetailList) => {
        detailMaterialDetailList(mode, parentInfo, record)
    }
    const materialColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
            sorter: {
                compare: (a: { materialCode: string; }, b: { materialCode: string; }) => {
                    if (a.materialCode.charCodeAt(0) == b.materialCode.charCodeAt(0)) {
                        return a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0)
                    }
                    return a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0)
                },
                multiple: 1,
            },
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '库房',
            width: 140,
            dataIndex: 'warehouseName',
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: isMaterialModel()
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: isMaterialModel()
        }, {
            title: '配件费',
            width: 100,
            dataIndex: 'materialAmount',
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            editable: isMaterialModel(),
            render: (text: string) => text + "%"
        }, {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',

        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: isMaterialModel()
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isMaterialModel() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />

        }
    ];

    const typeMaterialList = {
        "add": [...detailMaterialAddList],
        "edit": [...detailMaterialEditList],
        "look": [...detailMaterialLookList],
    }
    const newSelectMaterialColums = () =>
        materialColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "appointment", "roleCodes": roles };
        return getRoleColumns("appointment", "维修用料", newSelectMaterialColums(), params);
    }, [roles, typeMaterialList[mode], materialColumns]);
    const handleMaterialSave = (row: IMaterialDetailList) => {
        let { num, price, discountRate, inventoryNum, purchasePrice, termNum, latestPurPrice } = row
        let newPurPrice = latestPurPrice !== 0 ? latestPurPrice : purchasePrice
        // num = +formatIntPoint(num, inventoryNum, "选择数量>=可用库存数量");  //数量
        num = mode === "add" ? +formatIntPoint(num, inventoryNum, "选择数量>=可用库存数量") : +formatIntPoint(num, termNum ? termNum : inventoryNum, "选择数量>=可用库存数量");  //数量

        price = +formatIntPoint1(price, newPurPrice, `修改价格不应小于进货价${newPurPrice}`);  //价格
        price = +formatNum(price);
        discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%')
        let newRow = {
            ...row,
            num,
            price,
            discountRate,
            materialAmount: +formatNum(num * price),
            receivableAmount: +formatNum((num * price * discountRate) / 100),
        }

        let newData = mode === "edit" ? detailMaterialEditList : detailMaterialAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailMaterialEditList([...newData]) : setDetailMaterialAddList([...newData])
    }

    //设置维修用料选中的行和数据
    const setTypeMaterialDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeMaterialDetailDataRow = async (selectedRows: IMaterialDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="维修用料" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns}
                dataSource={typeMaterialList[mode] as IMaterialDetailList[]}
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailMaterialAddDataRowKeys : detailMaterialEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetailList[]) => {
                            setTypeMaterialDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}